module.exports = __webpack_public_path__ + "img/1581315905.9cb7ec45.jpg";